import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mx-4" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "PHIẾU XUẤT KHO KHÁC")
], -1)
const _hoisted_2 = { class: "text-end" }

import { computed, onMounted, ref } from 'vue';
import { useRouterCustom } from '@/core/hooks/use-router-custom';
import { setCurrentPageTitle } from '@/core/helpers/breadcrumb';
import { useCreatingForm } from '@/core/hooks/use-creating-form';
import { useButtonCustom } from '@/core/hooks/use-button-custom';
import { useLoading } from '@/core/hooks/use-loading';
import {
  IKhoResponseBase,
  IVatTuResponseBase,
  IVatTuTrongKhoResponseBase,
  IVatTuXuatKhoResponseBase, ReceiptBaseResponse
} from '@/core/interfaces/ApiResponses';
import { KhoService } from '@/core/services/Kho.service';
import { UserService } from '@/core/services/UserService';
import { AddVatTuItemsFor } from '@/core/enums/addVatTuItemsFor.enum';
import { getErrorMsg, swalErrNotification, swalNotification } from "@/core/helpers/utils";
import { ICreateOrUpdatePhieuXuatKhac } from '@/core/interfaces/Models';
import AddVatTuItemV2 from '@/components/add-vat-tu-items-v2/AddVatTuItemV2.vue';
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';
import DivCol from '@/layout/_shared/DivCol.vue';
import DivRow from '@/layout/_shared/DivRow.vue';
import PageRowLayout from '@/layout/_shared/PageRowLayout.vue';
import PhieuXuatKhoService from '@/core/services/Receipt.service';
import LabelCustom from '@/components/shared/label-custom/LabelCustom.vue';
import TaiKhoanSelection from '@/components/shared/tai-khoan-selection/TaiKhoanSelection.vue';
import TaiKhoanSelectionV2 from '@/components/shared/tai-khoan-selection/TaiKhoanSelectionV2.vue';
import VatTuKhoTable from '@/views/crafted/pages/kho/vat-tu-kho-table/VatTuKhoTable.vue';
import useFormInput from '@/core/hooks/use-form-input';
import useTaiKhoan from '@/core/hooks/useTaiKhoan';
import usePhieuXuat from '@/core/hooks/usePhieuXuat';
import ResponsiveLayout from '@/layout/_shared/ResponsiveLayout.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const { id: idKho, goBack, replace } = useRouterCustom('idKho');

const { id: idPhieuXuat } = useRouterCustom('idPhieuXuat');

const { isCreating, isDetail, formRef } = useCreatingForm();

const { ButtonsType, ButtonTypeColors } = useButtonCustom();

const khoDetail = ref<IKhoResponseBase | null>(null);

const nguoiDungItems = ref<any[]>([]);

const vatTuXuatKhoItems = ref<IVatTuXuatKhoResponseBase[]>([]);

const { onSelectTaiKhoan, clearTaiKhoanData, tkData, setTkData } = useTaiKhoan();

const { isPhieuXuatEditable, allowEditingTaiKhoan } = usePhieuXuat();

const vatTuSelectedComputed = computed<IVatTuXuatKhoResponseBase[]>(() => vatTuXuatKhoItems.value.map(item => ({
  ...item,
  don_gia: item.pivot?.don_gia ? +item.pivot.don_gia : 0,
  so_luong: item.pivot?.so_luong ? +item.pivot?.so_luong : 0,
})));

const vatTuSelectedDisplayingItems = computed<IVatTuTrongKhoResponseBase[]>(() => vatTuXuatKhoItems.value.map(item => ({
  ...item,
  pivot: {
    id_kho: khoDetail.value?.id ?? 0,
    id_vat_tu: item.id,
    so_luong: +item.pivot.so_luong,
    don_gia: item.pivot.don_gia ? +item.pivot.don_gia : 0,
  }
})))

const { startLoading, endLoading } = useLoading();

const isAddVatTuModalDisplay = ref<boolean>(false);

const fetchKhoDetail = async () => {
  try {
    const { data: { data: khoResponse } } = await KhoService.get(idKho.value);

    khoDetail.value = khoResponse;
  } catch (e) {
    await endLoading();

    await swalErrNotification(e, 'Có lỗi khi lấy thông tin kho');
  }
}

const dateValidation = (_, value, callback) => {
  if (!value) {
    callback(new Error('Bắt buộc phải nhập ngày xuất'));
  }

  callback();
}

const rules = ref({
  id_nguoi_nhan: [
    {
      required: true,
      message: 'Phải nhập tên người nhận hàng',
      trigger: 'blur',
    },
    {
      type: 'number',
      message: 'Phải nhập tên người nhận hàng',
      min : 1,
    }
  ],
  ngay: [
    {
      validator: dateValidation,
      trigger: 'change',
    },
  ],
  so_bien_ban: [
    {
      required: true,
      message: 'Phải nhập số biên bản',
      trigger: 'blur',
    },
  ],
});

const fetchNguoiDung = async () => {
  const { data: { data: { data } } } = await UserService.list();

  nguoiDungItems.value = data;
}

const form = ref({
  id_nguoi_nhan: -1,
  ngay: new Date(),
  so_bien_ban: '',
  ly_do: `Phiếu xuất kho khác`,
});

const phieuXuatKhoDetail = ref<ReceiptBaseResponse | null>(null);

const fetchPhieuXuat = async () => {
  try {
    const { data: { data } } = await PhieuXuatKhoService.get(idPhieuXuat.value);

    phieuXuatKhoDetail.value = data;

    vatTuXuatKhoItems.value = phieuXuatKhoDetail.value.vat_tu_xuat_kho;

    const { id_nguoi_nhan, ngay, ly_do, so_bien_ban } = phieuXuatKhoDetail.value;

    form.value.id_nguoi_nhan = id_nguoi_nhan;

    form.value.ly_do = ly_do || 'Phiếu xuất kho khác';

    form.value.ngay = ngay ? new Date(ngay) : new Date();

    form.value.so_bien_ban = so_bien_ban;

    if (phieuXuatKhoDetail.value.tk_no?.ma_tk) {
      setTkData(phieuXuatKhoDetail.value.tk_no.ma_tk, 'ma_tk')
    }

    if (phieuXuatKhoDetail.value.tk_no?.ten_tk) {
      setTkData(phieuXuatKhoDetail.value.tk_no.ten_tk, 'ten_tk')
    }

    if (phieuXuatKhoDetail.value.tk_no?.ma_ct) {
      setTkData(phieuXuatKhoDetail.value.tk_no.ma_ct, 'ma_ct')
    }
  } catch (e) {
    await endLoading();

    await swalErrNotification(e, 'Có lỗi khi lấy thông tin kho');
  }
}

const editable = computed(() => isPhieuXuatEditable(phieuXuatKhoDetail.value));

const editableTaiKhoan = computed(() => allowEditingTaiKhoan(phieuXuatKhoDetail.value) || isCreating.value || editable.value);

onMounted(async () => {
  await startLoading();

  await fetchKhoDetail();

  await fetchNguoiDung();

  if ((isDetail.value || isCreating) && idPhieuXuat.value) await fetchPhieuXuat();

  await endLoading();

  setCurrentPageTitle(`Phiếu xuất kho khác (${khoDetail.value?.ten_kho || ''})`);
});

const addedVatTuItems = ({
  selectingVatTuItems,
}: {
  selectingVatTuItems: IVatTuResponseBase[],
}) => {
  isAddVatTuModalDisplay.value = false;

  const newItems: IVatTuXuatKhoResponseBase[] = selectingVatTuItems.map((item) => ({
    ...item,
    pivot: {
      don_gia: item.don_gia,
      id_kho: khoDetail.value?.id || 0,
      id_phieu_xuat_kho: 0,
      id_vat_tu: item.id,
      so_luong: item.so_luong,
    },
  }));

  vatTuXuatKhoItems.value = [...vatTuXuatKhoItems.value, ...newItems];
}

const unselectVatTu = ({ vatTu: { id } }) => {
  const index = vatTuXuatKhoItems.value.findIndex(({ id: idVatTu }) => id === idVatTu);

  if (index >= 0) {
    vatTuXuatKhoItems.value.splice(index, 1);
  }
}

const transformPayload = (): ICreateOrUpdatePhieuXuatKhac => ({
  ...(!isCreating.value && {
    id_phieu_xuat: idPhieuXuat.value,
  }),
  id_kho: idKho.value,
  id_nguoi_nhan: form.value.id_nguoi_nhan,
  ly_do: form.value.ly_do,
  ngay: form.value.ngay,
  so_bien_ban: form.value.so_bien_ban,
  vat_tu_items: vatTuXuatKhoItems.value,
  ma_tk_no: tkData.value.maTaiKhoan,
  ten_tk_no: tkData.value.tenTaiKhoan,
  ...(tkData.value.maChiTiet && {
    ma_ct_no: tkData.value.maChiTiet,
  }),
});

const { focusFirstErrInput } = useFormInput();

const onSubmit = async () => {
  if (!formRef.value) {
    return;
  }

  if (!vatTuXuatKhoItems.value.length) {
    swalErrNotification(null, 'Chưa chọn vật tư');

    return;
  }

  if (!tkData.value.maTaiKhoan || !tkData.value.tenTaiKhoan) {
    await focusFirstErrInput('tai-khoan-selection_tai-khoan');

    await swalNotification(
        'Bắt buộc phải nhập mã tài khoản',
        'error',
    );

    return;
  }

  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      await startLoading();

      await endLoading();

      try {
        const { data: { data } } = await PhieuXuatKhoService.createOrUpdatePhieuXuatKhac(transformPayload());

        await replace(`/quan-ly/bien-ban-giai-the/0/phieu-xuat/chi-tiet/${data.id}`);
      } catch (e) {
        await endLoading();

        await swalNotification(
          getErrorMsg(e),
          'error',
        );
      }
    }

    return false;
  });
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (khoDetail.value)
      ? (_openBlock(), _createBlock(AddVatTuItemV2, {
          key: 0,
          "is-modal-open": isAddVatTuModalDisplay.value,
          "kho-id": khoDetail.value.id,
          "use-for": _unref(AddVatTuItemsFor).PHIEU_NHAP_KHO_KHAC,
          "vat-tu-selected": vatTuSelectedComputed.value,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (isAddVatTuModalDisplay.value = false)),
          onAdded: addedVatTuItems
        }, null, 8, ["is-modal-open", "kho-id", "use-for", "vat-tu-selected"]))
      : _createCommentVNode("", true),
    _createVNode(PageRowLayout, null, {
      "page-row-header": _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(isCreating) ? 'Tạo mới' : _unref(isDetail) ? 'Chi tiết' : 'Chỉnh sửa'), 1)
      ]),
      "page-row-action-button": _withCtx(() => [
        _createVNode(ButtonCustom, {
          "button-type": _unref(ButtonsType).BACK,
          onClick: _unref(goBack)
        }, null, 8, ["button-type", "onClick"])
      ]),
      "page-row-content": _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form.value,
          rules: rules.value,
          onSubmit: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (onSubmit()), ["prevent"]))
        }, {
          default: _withCtx(() => [
            (khoDetail.value)
              ? (_openBlock(), _createBlock(ResponsiveLayout, { key: 0 }, {
                  "col-1": _withCtx(() => [
                    _createVNode(LabelCustom, { "is-bolder": true }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Kho: ")
                      ]),
                      _: 1
                    })
                  ]),
                  "col-2": _withCtx(() => [
                    _createVNode(_component_RouterLink, {
                      target: "_blank",
                      to: {
            name: 'chi-tiet-kho',
            params: {
              id: khoDetail.value?.id,
            },
          }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(khoDetail.value?.ten_kho), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  "col-3": _withCtx(() => [
                    _createVNode(LabelCustom, {
                      "is-bolder": true,
                      "is-required": true
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Người nhận hàng ")
                      ]),
                      _: 1
                    })
                  ]),
                  "col-4": _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "id_nguoi_nhan",
                      class: "mb-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: form.value.id_nguoi_nhan,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.id_nguoi_nhan) = $event)),
                          disabled: !editable.value && !_unref(isCreating),
                          name: "id_nguoi_nhan",
                          onChange: () => {}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "Chưa chọn",
                              value: -1
                            }),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nguoiDungItems.value, (user) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: user.id,
                                label: user.ho_va_ten,
                                value: user.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(ResponsiveLayout, null, {
              "col-1": _withCtx(() => [
                _createVNode(LabelCustom, {
                  "is-bolder": true,
                  "is-required": true
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Ngày: ")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  prop: "ngay",
                  class: "mb-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: form.value.ngay,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.ngay) = $event)),
                      class: "w-100",
                      disabled: !editable.value && !_unref(isCreating),
                      format: "DD/MM/YYYY",
                      name: "ngay",
                      placeholder: "Chọn ngày",
                      onFocus: _cache[3] || (_cache[3] = ($event: any) => ($event.target.select()))
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              "col-3": _withCtx(() => [
                _createVNode(LabelCustom, {
                  "is-bolder": true,
                  "is-required": true
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Số biên bản: ")
                  ]),
                  _: 1
                })
              ]),
              "col-4": _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  prop: "so_bien_ban",
                  class: "mb-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: form.value.so_bien_ban,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.so_bien_ban) = $event)),
                      disabled: !editable.value && !_unref(isCreating),
                      name: "so_bien_ban",
                      onFocus: _cache[5] || (_cache[5] = ($event: any) => ($event.target.select()))
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(TaiKhoanSelectionV2, {
              label: "T/tin TK nợ:",
              "read-only": !editableTaiKhoan.value,
              "ma-tai-khoan-prop": _unref(tkData).maTaiKhoan ? parseInt(_unref(tkData).maTaiKhoan) : undefined,
              "ma-chi-tiet-prop": _unref(tkData).maChiTiet ? _unref(tkData).maChiTiet : undefined,
              onOnSelect: _unref(onSelectTaiKhoan),
              onOnClear: _unref(clearTaiKhoanData)
            }, null, 8, ["read-only", "ma-tai-khoan-prop", "ma-chi-tiet-prop", "onOnSelect", "onOnClear"]),
            _createVNode(ResponsiveLayout, null, {
              "col-1": _withCtx(() => [
                _createVNode(LabelCustom, {
                  "is-bolder": true,
                  "is-required": true
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Lý do: ")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  prop: "ly_do",
                  class: "mb-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: form.value.ly_do,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.ly_do) = $event)),
                      disabled: !editable.value && !_unref(isCreating),
                      name: "ly_do",
                      type: "textarea",
                      onFocus: _cache[7] || (_cache[7] = ($event: any) => ($event.target.select()))
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              (editable.value || _unref(isCreating))
                ? (_openBlock(), _createBlock(ButtonCustom, {
                    key: 0,
                    "button-type": _unref(ButtonsType).ADD,
                    "color-type": _unref(ButtonTypeColors).SECONDARY,
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (isAddVatTuModalDisplay.value = true))
                  }, {
                    "button-label": _withCtx(() => [
                      _createTextVNode("Vật tư")
                    ]),
                    _: 1
                  }, 8, ["button-type", "color-type"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(DivRow, { class: "mt-5" }, {
              default: _withCtx(() => [
                _createVNode(DivCol, { cols: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(VatTuKhoTable, {
                      "empty-text": "Chưa có vật tư được chọn",
                      "is-delete-button-display": true,
                      "vat-tu-items": vatTuSelectedDisplayingItems.value,
                      onOnDelete: unselectVatTu
                    }, null, 8, ["vat-tu-items"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(DivRow, { class: "mt-5" }, {
              default: _withCtx(() => [
                _createVNode(DivCol, { cols: 11 }),
                _createVNode(DivCol, { class: "d-flex justify-content-end" }, {
                  default: _withCtx(() => [
                    _createVNode(ButtonCustom, {
                      "button-type": _unref(ButtonsType).SAVE,
                      "color-type": _unref(ButtonTypeColors).SUCCESS,
                      onClick: onSubmit
                    }, {
                      "button-label": _withCtx(() => [
                        _createTextVNode("Lưu")
                      ]),
                      _: 1
                    }, 8, ["button-type", "color-type"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    })
  ], 64))
}
}

})